import { render, staticRenderFns } from "./luckyTurntable.vue?vue&type=template&id=3ccea61d&scoped=true&"
import script from "./luckyTurntable.vue?vue&type=script&lang=js&"
export * from "./luckyTurntable.vue?vue&type=script&lang=js&"
import style0 from "./luckyTurntable.vue?vue&type=style&index=0&id=3ccea61d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccea61d",
  null
  
)

export default component.exports